import { render } from "./useful.vue?vue&type=template&id=27af00a4&scoped=true"
import script from "./useful.vue?vue&type=script&lang=js"
export * from "./useful.vue?vue&type=script&lang=js"

import "./useful.vue?vue&type=style&index=0&id=27af00a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27af00a4"]])

export default __exports__